<style lang="scss">
.mdm-setup {
}
</style>

<template>
  <!-- Error page-->
  <div>
    <div v-if="loading" class="d-flex flex-column justify-content-center align-items-center mt-5">
      <h1>Verifying details, please wait...</h1>

      <b-spinner variant="primary" label="Loading" />
    </div>

    <h1 v-else>You do not have valid access to this app</h1>
  </div>
  <!-- / Error page-->
</template>

<script>
import LogsService from '@/services/LogsService';
import axios from '@axios'
import { setRegion, getRestEndpoint } from '../../../endpoints';

export default {
  components: {},
  data() {
    return {
      loading: true,
    }
  },
  computed: {},
  mounted() {
    // uncomment for test
    // const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Ijk5OTgxM2M0LTdlMmUtNGZmOC1hNzA3LWRiZTY5MjJkNTM4OSIsImVudGVycHJpc2VfaWQiOiJMQzAxdHNweTdqIiwidHlwZSI6Im93bmVyIiwicGFja2FnZXMiOlsiY29tLm1hZGVwdXJwbGUuaXBsYXllciIsInVrLmNvLmFpZmFjdG9yeS5nb2ZyZWUiLCJjb20ubWFkZXB1cnBsZS5wdy5icml0YW5uaWNhIiwiY29tLm1hZGVwdXJwbGUuYnViYmxlcG9wIiwiY29tLm1hZGVwdXJwbGUucHVycGxlYm9va3MiLCJjb20ubWFkZXB1cnBsZS5wdXJwbGVyYWRpbyIsImNvbS5tYWRlcHVycGxlLmNvbm5lY3Q0IiwiY29tLm1hZGVwdXJwbGUucmVmbGVjdGlvbiIsImNvbS5tYWRlcHVycGxlLnRldHJpcyIsImNvbS5tYWRlcHVycGxlLnNodWZmbGUiLCJjb20ubWFkZXB1cnBsZS53b3Jrb3V0IiwiY29tLm1hZGVwdXJwbGUuZmxhcGNyb3ciLCJjb20ubWFkZXB1cnBsZS5zdWRva3VwdXJwbGUiLCJjb20ubWFkZXB1cnBsZS5mcnVpdE5pbmphIiwiY29tLm1hZGVwdXJwbGUuc25ha2UyIiwiY29tLm1hZGVwdXJwbGUubmV3c3N0YW5kIiwiY29tLm1hZGVwdXJwbGUucHBpYyIsImNvbS5tYWRlcHVycGxlLnB2aWMiLCJjb20ubWFkZXB1cnBsZS5wdmN0IiwiY29tLm5vcmR2cG4uYW5kcm9pZCIsImNvbS5tYWRlcHVycGxlLmNoYW5uZWw5IiwiY29tLm1hZGVwdXJwbGUuYWJjIiwiY29tLm1hZGVwdXJwbGUuc2JzIiwiZWxlY3Ryb24uY29tLm1hZGVwdXJwbGUuYXJnb3MiLCJjb20ubWFkZXB1cnBsZS5iYmNzb3VuZHMiLCJjb20uZ29vZ2xlLmFuZHJvaWQuZGVza2Nsb2NrIiwiY29tLm1hZGVwdXJwbGUubGlmZWxpbmUiLCJtYWRlcHVycGxlb3MuY29tLnRlc2NvIiwibWFkZXB1cnBsZW9zLmNvbS5saW1waW5nY2hpY2tlbiIsIm1hZGVwdXJwbGVvcy5jb20uYmRhIiwibWFkZXB1cnBsZW9zLmNvbS5ic2x6b25lIiwibWFkZXB1cnBsZW9zLmNvbS5ybmlkIiwiY29tLm1hZGVwdXJwbGUuYWxhcm0iLCJjb20ub25lcGx1cy5kZXNrY2xvY2siLCJjb20uYmV0dGVyLmFsYXJtIiwibWFkZXB1cnBsZW9zLmNvbS5jcWMtYXJub2xkLWxvZGdlIiwibWFkZXB1cnBsZW9zLmNvbS5jcWMtcmFtcHRvbiIsImNvbS5tZWRpYS5iZXN0cmVjb3JkZXIuYXVkaW9yZWNvcmRlciIsImNvbS5tYWRlcHVycGxlLmFmbCIsImNvbS5tYWRlcHVycGxlLm5vdGVzIiwiY29tLm1hZGVwdXJwbGUubnJsIl0sImV4cCI6MTY1MTkyMDY1M30.Eak-TjG0HGEf8AWwgcHu9z3WIV6WRZlyc8AmkpF9W1w';
    // this.$store.dispatch('auth/setLocalUserToken', token);
    // this.convertToken(token);
    // todo comment above when not testing

    // listen for a custom electron event
    window.addEventListener('electronSetup', data => {
      const Token = data.detail.token;
      const Country = data.detail.country;

      if (Country) {
        setRegion(Country); // Sets the region use in REST_ENDPOINT. Defaults to 'uk'.
      }

      // Set BaseURL based on region selected above.
      axios.defaults.baseURL = getRestEndpoint();

      if (Token) {
        this.$store.commit('SET_IS_ELECTRON', true);
        this.$store.dispatch('auth/setLocalUserToken', Token);

        this.convertToken(Token);
      }
    });
  },
  methods: {
    convertToken(token) {
      // console.log('>> token is ', token);
      setTimeout(() => {
        // console.log('token to convert', token);
        LogsService.convertMdmToken(token).then(res => {
          // console.log('converted token', res);
          this.$store.dispatch('auth/setLocalUserToken', res.data.token);
          this.$store.dispatch('sendStat', { meta: {}, description: 'Opened Purple Visits App' });
          this.$router.push({ name: 'dashboard' });
        }).catch(err => {
          console.log('You do not have valid access', err);
          this.loading = false;
        });
      });
    }
  }
}
</script>
